export default {
    data() {
        return {
            eanCodeScanning: false,
            lastEventTime: null,
            eanProcessingCode: '',
            handleEANCodeScanner: null,
        }
    },
    methods: {
        listenForEANCodeScanner(callBack) {
            this.handleEANCodeScanner = callBack
            window.addEventListener('keydown', this.EANCodeScanner)
        },
        stopListenForEANCodeScanner() {
            this.handleEANCodeScanner = null
            window.removeEventListener('keydown', this.EANCodeScanner)
        },
        EANCodeScanner(event) {
            // EAN paste tester
            if (process.env.VUE_APP_ENV === 'local') {
                if (event.ctrlKey && event.key === 'Insert') {
                    navigator.clipboard.readText().then(clipText => {
                        for (let i = 0; i < clipText.length; i++) {
                            const event = new KeyboardEvent('keydown', { key: clipText[i] })

                            window.dispatchEvent(event)
                        }
                        // eslint-disable-next-line no-console
                        console.log(clipText)
                    })

                    return
                }
            }

            const ignoredKeys = ['Shift', 'Enter', 'Alt', 'Control']

            if (ignoredKeys.includes(event.key)) return

            if (this.eanCodeScanning === false) {
                this.eanCodeScanning = true
                setTimeout(() => {
                    this.handleEANCodeScanner(this.eanProcessingCode)
                    this.eanCodeScanning = false
                    this.eanProcessingCode = ''
                }, 100)
            }

            this.eanProcessingCode += event.key
            this.lastEventTime = event.timeStamp
        },
    },
}
